module.exports = __webpack_public_path__ + "img/TraditionalGapWideningBoneSegment.e2cc913e.png";